module.exports = __webpack_public_path__ + "img/icon-cont-1.3a0603ce.png";